import { Component, HostListener, ViewChild } from '@angular/core';
import { SiaI18nDirective, SiaTranslatePipe } from '@sia/shared';
import {
  DxDataGridComponent,
  DxDataGridModule,
  DxNumberBoxModule,
  DxSelectBoxModule,
  DxSwitchModule,
  DxTextBoxModule,
} from 'devextreme-angular';
import {
  DxiColumnModule,
  DxoColumnChooserModule,
  DxoEditingModule,
  DxoFilterRowModule,
  DxoGroupPanelModule,
  DxoGroupingModule,
  DxoHeaderFilterModule,
  DxoLoadPanelModule,
  DxoLookupModule,
  DxoRemoteOperationsModule,
  DxoScrollingModule,
  DxoSearchPanelModule,
  DxoSelectionModule,
  DxoSortingModule,
} from 'devextreme-angular/ui/nested';
import { SiaGridConfigTab } from '../sia-grid-config-tab/sia-grid-config-tab.component';

@Component({
  selector: 'sia-grid-config-detail',
  templateUrl: './sia-grid-config-detail.component.html',
  styleUrls: ['./sia-grid-config-detail.component.scss'],
  standalone: true,
  imports: [
    SiaI18nDirective,
    DxSelectBoxModule,
    DxTextBoxModule,
    DxSwitchModule,
    DxNumberBoxModule,
    DxDataGridModule,
    DxiColumnModule,
    DxoLookupModule,
    DxoEditingModule,
    DxoSelectionModule,
    DxoRemoteOperationsModule,
    DxoSortingModule,
    DxoColumnChooserModule,
    DxoLoadPanelModule,
    DxoHeaderFilterModule,
    DxoFilterRowModule,
    DxoSearchPanelModule,
    DxoGroupPanelModule,
    DxoGroupingModule,
    DxoScrollingModule,
    SiaTranslatePipe,
  ],
})
export class SiaGridConfigDetailComponent extends SiaGridConfigTab {
  @ViewChild(DxDataGridComponent, { static: false })
  childDataGrid: DxDataGridComponent | undefined;

  gridConfDetailEditorType: any[] = [
    { id: '', name: 'Default' },
    { id: 'dxTextArea', name: 'Text Area' },
  ];

  gridConfEditingTypes: string[] = [
    'nessuno',
    'batch',
    'row',
    'popup',
    'external page',
    'navigazione',
  ];
  // FILTRI
  gridConfPatternsTypes: any[] = [
    { id: 'SiaSessionParam', name: 'Parametro in sessione' },
    { id: '@StaticValue', name: 'Valore statico' },
  ];

  @HostListener('window:unload')
  ngOnDestroy() {
    this.destroyDxComponent(this.childDataGrid, 'gridConfigDetails');
    this.gridConfDetailEditorType = [];
    this.gridConfEditingTypes = [];
    this.gridConfPatternsTypes = [];
    super.ngOnDestroy();
  }

  get editType() {
    return this.gridConf.editType ?? '';
  }

  set editType(value: string) {
    this.gridConf.editType = value;
    this.gridConf.allowRowReordering = false;
    this.gridConf.allowAdding = false;
    this.gridConf.allowUpdating = false;
    this.gridConf.allowDeleting = false;
    this.gridConf.externalPage = '';
    this.gridConf.addingController = '';
    this.gridConf.updatingController = '';
    this.gridConf.deletingController = '';
    this.gridConf.editPopupColCount = '';
    this.gridConf.editPopupArea1Title = '';
    this.gridConf.editPopupArea2Title = '';
    this.gridConf.editPopupWidth = 0;
    this.gridConf.editPopupHeight = 0;
  }

  get title(): string {
    return this._gridConfig?.choisesTitle ?? '';
  }

  set title(v: string) {
    if (this._gridConfig) {
      this._gridConfig.choisesTitle = v;
    }
  }

  getChoices() {
    if (!this.gridConf.choisesItems) {
      this.gridConf.choisesItems = [];
    }
    // console.log('this.gridConf.choisesItems', this.gridConf.choisesItems);
    // console.log('this._gridConfig 1', this._gridConfig);
    return this.gridConf.choisesItems;
  }
}
